// DebugTracking.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle } from 'styled-components';
import { useLocation } from 'react-router-dom';

import { NULL_FUNCTION } from '../resource/defaults.js';

const DebugTrackingStyle = createGlobalStyle`
[data-element_id] {
  &:not([data-element_id='']) {
    &::before {
      position: absolute;
      z-index: 20;
      color: #f6f6f6;
      font-size: 10px;
      white-space: pre-wrap;
      word-wrap: break-word;
      background-color: rgb(0, 0, 0);
      content: attr(data-element_id);
      transform: translateY(50%);
      line-height: 1;
      opacity: 0.8;
      pointer-events: none;
    }
    &:nth-child(even)::before {
      transform: translateY(-50%);
    }
    &:hover::before {
      opacity: 1;
    }
  }
}
`;

export const DebugTracking = ({
  isElementIdDebugTrackingEnabled = false,
  updateDebugTracking = NULL_FUNCTION,
}) => {
  const location = useLocation();
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const nextState =
      !!isElementIdDebugTrackingEnabled || searchParams.has('debug-tracking');
    if (nextState !== isElementIdDebugTrackingEnabled) {
      updateDebugTracking({
        key: 'elementId',
        value: nextState,
      });
    }
  }, [isElementIdDebugTrackingEnabled, location.search, updateDebugTracking]);
  if (!isElementIdDebugTrackingEnabled) return null;
  return <DebugTrackingStyle />;
};

DebugTracking.propTypes = {
  isElementIdDebugTrackingEnabled: PropTypes.bool,
  updateDebugTracking: PropTypes.func,
};

export default DebugTracking;
